import { render } from "./finish-27.vue?vue&type=template&id=0c4a3e57&scoped=true"
import script from "./finish-27.vue?vue&type=script&lang=js"
export * from "./finish-27.vue?vue&type=script&lang=js"

import "./finish-27.vue?vue&type=style&index=0&id=0c4a3e57&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4a3e57"]])

export default __exports__